/*
 * @Author: Chris 
 * @Date: 2022-07-29 10:34:00 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-08 17:26:10
 */

<template>
  <el-drawer
    size="25%"
    destroy-on-close
    :modal="false"
    @open="opendrawer"
    :visible.sync="this.$store.state.Drawer_UserManagement_Edit"
    :with-header="false"
    :before-close="closeDrawer"
  >
    <div class="drawer" v-loading="loading">
      <div class="drawer_header">
        <div class="header_title">
          编辑公司
          <div class="bgIMg"></div>
        </div>
        <i class="el-icon-close" @click="closeDrawer"></i>
      </div>
      <div class="drawer_body">
        <div class="body_input">
          <div class="input_name">公司名称</div>
          <el-input
            class="input_input"
            v-model="companyData.companyName"
            placeholder="请输入公司名称"
          ></el-input>
        </div>
        <div class="body_input">
          <div class="input_name">主管理员</div>
          <el-input
            class="input_input"
            v-model="companyData.userName"
            :disabled="true"
          ></el-input>
        </div>
        <div class="body_input">
          <div class="input_name">用户状态</div>
          <div class="input_radio">
            <el-radio v-model="state" label="0">停用</el-radio>
            <el-radio v-model="state" label="1">启用</el-radio>
          </div>
        </div>
        <div class="body_input">
          <div class="input_name">故障分类标准</div>
          <el-select
            class="input_input"
            v-model="companyData.faultStandardId"
            placeholder="请选择故障分类标准">
            <el-option
              v-for="item in faultStandardList"
              :key="item.faultStandardId"
              :label="item.faultStandardName"
              :value="item.faultStandardId">
            </el-option>
          </el-select>
        </div>
        <div class="body_input">
          <div class="input_name">物模型标准</div>
          <el-select
            class="input_input"
            v-model="companyData.propertyStandardId"
            placeholder="请选择物模型标准">
            <el-option
              v-for="item in propertyList"
              :key="item.propertyStandardId"
              :label="item.propertyStandardName"
              :value="item.propertyStandardId">
            </el-option>
          </el-select>
        </div>
        <div class="bottom_button">
          <!-- <div class="buttom_Del_line" @click="deleteUser">删除公司</div> -->
          <div class="buttom_Del marin_l" @click="onSubmit">确定</div>
          <!-- <div class="buttom_Del_ban marin_l">确定</div> -->
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {
  authdeptupdate,
  authdeptcompany,
  getFaultList,
  getPropertyList
} from "../../../api/api";

export default {
  name: "modifyCompanyInformation",
  props: ["choosecompanyMsg"],
  data() {
    return {
      companyData: {}, //公司信息
      state: "0", //用户状态

      // 标准
      faultStandardList: [],
      propertyList: [],
      loading: false,
    };
  },
  created() {
    this.getFaultList();
  },
  methods: {
    // 获取标准和物模型
    getFaultList() {
      getFaultList().then(res => {
        this.faultStandardList = res.data || []
      })
      getPropertyList().then(res => {
        this.propertyList = res.data || []
      })
    },
    /**
     * 抽屉打开时，回显值
     * */

    opendrawer() {
      this.companyData = this.choosecompanyMsg;
      this.companyData.faultStandardId = this.choosecompanyMsg.faultStandardId || null;
      this.companyData.propertyStandardId = this.choosecompanyMsg.propertyStandardId || null;
      this.companyData.propertyStandardName = this.choosecompanyMsg.propertyStandardName || null;
      this.state = this.companyData.status == "enable" ? "1" : "0";
    },

    /**
     * 删除用户
     * */

    deleteUser() {
      this.$confirm(
        "是否确认删除该公司？删除后该公司将无法使用此系统。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let params = {
            companyIds: [this.$props.choosecompanyMsg.companyId],
          };
          authdeptcompany(params).then((res) => {
            if (res.code == 200) {
              this.closeDrawer();
              this.$emit("getUserListMethods");
              this.$notify.success({
                title: "成功",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {});
    },

    /**
     * 点击确定
     * */

    onSubmit() {
      if (this.loading) {
        return
      }
      this.loading = true;
      let params = {
        type: "company",
        id: this.companyData.companyId,
        companyName: this.companyData.companyName,
        status: this.state == 0 ? "stopUsing" : "enable",
        userId: this.companyData.userId,
        faultStandardId: this.companyData.faultStandardId,
        propertyStandardId: this.companyData.propertyStandardId
      };

      this.propertyList.forEach(item => {
        if (item.propertyStandardId === params.propertyStandardId) {
          params.propertyStandardName = item.propertyStandardName;
        }
      })

      authdeptupdate(params).then((res) => {
        if (res.code == 200) {
          this.$notify.success({
            title: "成功",
            message: res.msg,
          });
          this.$emit("getUserListMethods");
          this.closeDrawer();
        }
      }).finally(() => {
        this.loading = false;
      })
    },

    /**
     * 关闭抽屉
     * */

    closeDrawer() {
      this.companyData = "";
      this.$store.commit("SET_Drawer_UserManagement_Edit", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .drawer_header {
    cursor: pointer;
    user-select: none;
    border-bottom: 0.125rem solid #eeeeee;
    height: 3.375rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.25rem;
    box-sizing: border-box;
    .header_title {
      font-weight: 400;
      font-size: 1rem;
      position: relative;
      .bgIMg {
        position: absolute;
        bottom: 0;
        left: -0.5rem;
        width: 6.25rem;
        height: 0.625rem;
        background: linear-gradient(
          90deg,
          rgba(183, 40, 45, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
        border-radius: 0.5rem;
      }
    }
  }
  .drawer_body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .body_img {
      width: 5.5rem;
      height: 5.5rem;
      border-radius: 0.25rem;
      margin-top: 2rem;
    }
    .body_input {
      margin-top: 1.875rem;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 1.25rem;
      .input_name {
        width: 5rem;
      }

      .input_radio {
        width: 18.75rem;
        padding: 0 0.625rem;
        box-sizing: border-box;
      }

      .input_input {
        width: 18.75rem;
      }
    }
    .bottom_button {
      bottom: 2rem;
      position: absolute;
      display: flex;
    }
    .marin_l {
      margin-left: 0.75rem;
    }
  }
}
</style>